import { supabase } from "@/integrations/supabase/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const fetchProfile = async (userId: string) => {
  const { data, error } = await supabase
    .from("profile")
    .select("full_name, bio")
    .eq("user_id", userId)
    .single();
  if (error) throw new Error(error.message);
  return data;
};

export function useProfileQuery(userId: string | undefined) {
  return useQuery({
    queryKey: ["profile", userId],
    queryFn: () => {
      if (!userId) throw new Error("No user id");
      return fetchProfile(userId);
    },
    enabled: !!userId,
  });
}

export function useProfileMutation(userId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { full_name: string; bio?: string }) => {
      if (!userId) throw new Error("No user id");
      const { error } = await supabase
        .from("profile")
        .update({ full_name: data.full_name, bio: data.bio })
        .eq("user_id", userId);
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profile", userId] });
      toast.success("Profil mis à jour");
    },
  });
}
